import DiscoverIconSM from "@/components/DiscoverIconSm";
import {
  Center,
  Container,
  Divider,
  Heading,
  Text,
  VStack,
  useColorMode,
} from "@chakra-ui/react";
import { GetStaticProps } from "next";
import Head from "next/head";
import Image from "next/image";
import Link from "next/link";

interface BlogPost {
  title: string;
  content: string;
  slug: string;
  image?: string;
}

interface BlogIndexProps {
  posts: BlogPost[];
}

export default function BlogIndex({ posts }: BlogIndexProps) {
  return (
    <>
      <Head>
        <title>Songcards Blog</title>
        <meta
          name="description"
          content="Stories from the humans that make it all possible."
        />
        <meta itemProp="image" content="https://songcards.io/sc-pink.png" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta property="og:title" content="Songcards Blog" />
        <meta
          property="og:description"
          content="Stories from the humans that make it all possible."
        />
        <meta property="og:url" content="https://songcards.io/blog" />
        <meta property="og:image" content="https://songcards.io/sc-pink.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Songcards Blog" />
        <meta
          name="twitter:description"
          content="Stories from the humans that make it all possible."
        />
        <meta name="twitter:image" content="https://songcards.io/sc-pink.png" />
        <link rel="icon" href="/SC Icon_A_Light.svg" />
        <link rel="apple-touch-icon" href="/SC Icon_A_Light.svg" />
      </Head>
      <Container maxW="3xl" p={4} mb={100}>
        <Heading textAlign="center" mt={0} mb={10}>
          Songcards Blog
        </Heading>
        <Text textAlign="center" mt={2} mb={10}>
          Stories from the humans that make it all possible
        </Text>
        <br />
        <Center>
          <VStack spacing={10} align="stretch" maxW={"md"}>
            {posts.map((post) => (
              <Center key={post.slug}>
                <Link href={`/blog/${post.slug}`} passHref>
                  <VStack
                    spacing={4}
                    align="start"
                    _hover={{ textDecoration: "none", opacity: 0.9 }}
                  >
                    {post.image && (
                      <Image
                        src={post.image}
                        alt={post.title}
                        width={500}
                        height={500}
                        style={{
                          width: 500,
                          height: 500,
                          borderRadius: "2%",
                          objectFit: "cover",
                          borderColor: "white",
                          borderStyle: "solid",
                        }}
                        unoptimized
                      />
                    )}
                    <Heading size="md">{post.title}</Heading>
                    <Divider mt={5} mb={0} />
                  </VStack>
                </Link>
              </Center>
            ))}
            <DiscoverIconSM />
          </VStack>
        </Center>
      </Container>
    </>
  );
}

export const getStaticProps: GetStaticProps = async () => {
  const res = await fetch("https://api.songcards.io/blog-post/");
  const posts = await res.json();

  return {
    props: {
      posts,
    },
    revalidate: 86400,
  };
};
